// Typelizer digest 9ec606d60c07cce13d4c1f299a28c4c5
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /reset */
  reset: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/reset', {}, options),
    method: 'post',
  }),
}
